import {Route, UrlSegment, UrlSegmentGroup} from '@angular/router';

/*
  * Custom path matcher for this complex route parameters
  * path: 'licitacoes/:modalidade/:numero/:orgao'
  *
  * Este ParamMatcher é responsável por tratar o routeParam :numero é composto
  * por dois números separados por uma / (ex: 0071/2023), por ter uma / no meio
  * o Angular pensa que são 2 parametros, mas, na verdade é apenas um.
 */
export function LicitacaoGetOneRouterParamMatcher(segments: UrlSegment[], segmentGroup: UrlSegmentGroup, route: Route) {

  const {length} = segments;

  // Primeiro segmento é o prefixo 'licitacoes'
  const firstSegment = segments[0];

  if (firstSegment.path === 'licitacoes' && length === 5) {
    // Segundo segmento é a modalidade
    const modalidade = segments[1];

    // Segundo segmento é a modalidade
    const orgao = segments[4];

    // O número é seperado, pelo Angular Router, nos segmentos 2 e 3
    const numeroSegments = segments.slice(2, 4);

    const numeroPaths = numeroSegments.map(segment => segment.path);
    const mergedNumeros = numeroPaths.join('/'); // merge the splitted :number parameter back together
    const numeroSegment: UrlSegment = new UrlSegment(mergedNumeros, {id: mergedNumeros});

    return ({consumed: segments, posParams: { modalidade: modalidade, numero: numeroSegment, orgao: orgao }});
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/app/components/licitacao-get-one/router-param-matcher/licitacao-get-one-router-param-matcher.ts